import { Cancel } from '@mui/icons-material';
import { IconButton, ImageList, ImageListItem, ImageListItemBar } from '@mui/material';
import { AppConfig } from '../../../../constants/Constants';
import { ImageData } from '../../../../types/Images';

export const ImagesList = ({ images, onDelete }: { images: ImageData[]; onDelete: (data: ImageData) => void }) => {
  const handleDelete = (data: ImageData) => {
    onDelete(data);
  };
  return (
    <ImageList
      rowHeight={140}
      sx={{
        '&.MuiImageList-root': {
          gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))!important',
        },
      }}
    >
      {images.map((data, index) => {
        const imageUrl = `${AppConfig.baseImageUrl}${data.image.path}`;
        return (
          <ImageListItem key={index} cols={1} rows={1}>
            <img src={imageUrl} alt='rooms' loading='lazy' style={{ height: '100%' }} />
            <ImageListItemBar
              position='top'
              sx={{
                background: 'linear-gradient(to bottom, rgba(0,0,0,0.7)0%, rgba(0,0,0,0.3)70%, rgba(0,0,0,0)100%)',
              }}
              actionIcon={
                <IconButton sx={{ color: 'white' }} onClick={() => handleDelete(data)} size='large'>
                  <Cancel />
                </IconButton>
              }
            ></ImageListItemBar>
          </ImageListItem>
        );
      })}
    </ImageList>
  );
};
